<template>
  <div class="virtual-account-container">
    <div
      class="current-type-container is-bank"
      @click="showPaymentSelecter = true"
    >
      <span class="type-category">
        <template v-if="curPrice.TRANS_AMOUNT">
          <em class="payment-sleect-icon select-money-icon"></em>
          {{ curPrice.TRANS_AMOUNT }} {{ curPayType.show_currency }}
          <span class="get-text" style="margin: 0 5px">=</span>
          <template v-if="curPrice.COIN">
            {{ parseInt(curPrice.COIN || 0)
            }}<pay-ico :ico="directPayCoinIco"></pay-ico>
          </template>
          <template v-if="curPrice.EXTRA_COIN">
            + {{ parseInt(curPrice.EXTRA_COIN || 0)
            }}<pay-ico :ico="directPayExtraCoinIco"></pay-ico>
          </template>
          <span
            class="type-discount"
            v-if="curPrice.EXTRA_RATIO && curPrice.EXTRA_RATIO !== '0.00'"
          >
            {{ languages.gainPlus }}
            {{ ~~(curPrice.EXTRA_RATIO * 100) }}%
          </span>
        </template>
        <template v-else>請選擇匯款金額</template>
      </span>
      <Icon class="selected-type-icon"></Icon>
    </div>
    <div class="bank-tips-content">
      <div class="bank-tips-content_title">請注意：</div>
      <div>
        <p>1、銀行虛擬帳號儲值只能進行鑽石儲值哦</p>
        <p>2、匯款金額須與選擇金額保持一致才能正常獲取資源</p>
      </div>
    </div>
    <div class="submit-container">
      <div class="coupon-info-wrap">
        <div id="couponInfo" class="coupon-info default">
          <span>{{ letter.voucherPaytypeNotSupport }}</span>
        </div>
      </div>
      <div class="order-container">
        <div class="order-detail">
          <div class="order-detail-content">
            <template v-if="originCoin">
              {{ originCoin }}
              <pay-ico :ico="directPayCoinIco"></pay-ico>
            </template>
            <template v-if="extraCoin > 0"
              ><span style="margin: 0 5px">+</span>{{ extraCoin }}
              <pay-ico :ico="directPayExtraCoinIco"></pay-ico>
            </template>
          </div>
          <div class="order-detail-price">
            <p class="price">
              {{ languages.storeTotal }}：
              <span class="price-total"
                >{{ curPrice.TRANS_AMOUNT }}
                {{ curPayType.show_currency }}</span
              >
            </p>
          </div>
        </div>
        <Button
          pointClass="j-submit-nbtn"
          class="submit-btn normal-btn j-submit-nbtn"
          @click="postOrder"
          data-asyncbtn=""
        >
          獲取匯款帳號
        </Button>
      </div>
    </div>
    <bank-payment
      v-if="showPaymentSelecter"
      @closeSelecter="showPaymentSelecter = false"
      :curPayType="curPayType"
      :curPrice="curPrice"
      :pricesList="pricesList"
      :showChildSelector="showPaymentSelecter"
      @selectPrice="selectPrice"
      style="z-index: 1002"
    ></bank-payment>
    <PopupWindow
      @onCancel="handleJump"
      @onConfirm="handleJump"
      type="tips"
      v-if="showPopup"
      :languages="languages"
      :content="contentTips"
      class="bank-tip-popup"
    ></PopupWindow>
  </div>
</template>

<script>
import BankPayment from './BankPayment';
import { LOAD_BANK_PRICES, POST_ORDER } from '@store/officialWebStore';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import { mapGetters, mapState } from 'vuex';
import PayIco from '@components/officialWebStore/paytype/PayIco.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
const isEmptyObj = obj => Object.keys(obj).length === 0;
export default {
  name: 'bankPay',
  props: {
    curPayType: {
      require: true
    },
    gameId: {
      require: true
    },
    serverId: {
      require: true
    },
    roleId: {
      require: true
    },
    roleName: {
      require: true
    },
    languages: {
      require: true
    }
  },
  data() {
    return {
      curPrice: {},
      curCoins: {},
      pricesList: [],
      showPaymentSelecter: false,
      originCoin: 0,
      extraCoin: 0,
      totalCoin: 0,
      showPopup: false,
      contentTips:
        '發票處理事宜：於匯款完成七日內，請至下方『操作說明』選擇發票處理方式，若逾期未選擇，發票將默認捐贈“財團法人創世社會福利基金會”不做他用。',
      virtualAccount: '',
      canPost: true
    };
  },
  computed: {
    ...mapState({
      zipCode: state => state.zipCode
    }),
    letter() {
      return this.$store.state.letter;
    },
    coinName() {
      return this.$store.state.coinName;
    },
    ...mapGetters([
      'directPayCoinName',
      'directPayCoinIco',
      'directPayExtraCoinName',
      'directPayExtraCoinIco'
    ])
  },
  created() {
    this.initData();
  },
  watch: {
    curPrice: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.originCoin = +(newVal?.COIN || 0);
        this.extraCoin = +(newVal?.EXTRA_COIN || 0);
        this.totalCoin = this?.originCoin + this?.extraCoin;
      }
    }
  },
  methods: {
    initData() {
      this.$store
        .dispatch(LOAD_BANK_PRICES, {
          f_pay_type: this.curPayType?.f_pay_type,
          pay_type: this.curPayType?.pay_type,
          currency: this.curPayType?.currency,
          game_id: this.gameId,
          server_id: this.serverId
        })
        .then(res => {
          this.pricesList = res;
          this.curPrice = this.pricesList[0];
        })
        .catch(err => {
          this.$emit('showError', err);
        });
    },
    updateCurCoins(curCoins) {
      this.curCoins = curCoins;
    },
    postOrder() {
      window.webstorev2DataLayer.push({
        eventName: 'select_submit',
        eventValue: {
          product_type: '',
          cp_product_id: '',
          product_id: '',
          product_num: '1',
          product_currency: this.curPayType?.currency,
          product_money: this.curPrice?.TRANS_AMOUNT,
          local_currency: this.curPayType?.currency,
          local_money: this.curPrice?.TRANS_AMOUNT,
          f_pay_type: this.curPayType?.f_pay_type || '',
          pay_type: this.curPayType?.pay_type || '',
          is_coupon: 0,
          coupon_typeid: '',
          coupon_type_name: '',
          coupon_id: '',
          coupon_start_time: '',
          coupon_end_time: '',
          coupon_local_money: '',
          coupon_discount: ''
        }
      });
      if (isEmptyObj(this.curPrice)) {
        this.$emit('showError', '請選擇匯款金額');
        return;
      }
      if (!this.canPost) {
        return;
      }
      commonEmitUpload('click-submit-btn-manual', {
        event: 'click-submit-btn-manual',
        newPage: true,
        type: 'click'
      });
      this.canPost = false;
      const params = {
        f_pay_type: this.curPayType?.f_pay_type,
        paytype: this.curPayType?.pay_type,
        gameId: this.gameId,
        serverId: this.serverId,
        currency: this.curPayType?.currency,
        roleId: this.roleId,
        roleName: this.roleName,
        ptCode: 'global', // 区分新旧提单
        zipCode: this.zipCode,
        cid: globalConfig.getHrefParamUndecode('cid') || '',
        scid: globalConfig.getHrefParamUndecode('scid') || ''
      };
      this.$store
        .dispatch(POST_ORDER, params)
        .then(res => {
          this.canPost = true;
          this.showPopup = true;
          this.virtualAccount = res.data.virtual_account_info.virtual_account;
        })
        .catch(err => {
          this.canPost = true;
          this.$emit('showError', err.errmsg);
        });
    },
    selectPrice(price) {
      this.curPrice = price;
      this.$nextTick(() => {
        this.showPaymentSelecter = false;
      });
    },
    handleJump() {
      this.showPopup = false;
      this.$router.push({
        name: 'bankInfo',
        query: {
          amount: this.curPrice?.TRANS_AMOUNT,
          account: this.virtualAccount
        }
      });
    }
  },
  components: {
    BankPayment,
    PayIco
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.ico {
  width: 25px;
  margin: 0px 5px;
}
.type-category {
  display: flex;
  align-items: center;
}
.select-bank-amount-button {
  display: block;
  position: relative;
  box-sizing: border-box;
  background: white;
  line-height: 40px;
  font-size: 30px;
  color: #de6262;
  white-space: nowrap;
}
.coin-detail {
  &_left {
    display: flex;
    justify-content: space-between;
  }
  &-title {
    line-height: 100%;
    font-weight: bolder;
    font-size: 24px;
    color: #414141;
  }
  &-info {
    line-height: 100%;
    font-weight: bolder;
    font-size: 24px;
    color: #414141;
  }
  &_right {
    margin-top: 6px;
    line-height: 100%;
    text-align: right;
    .coin-detail-title {
      margin-right: 10px;
      height: 40px;
      line-height: 40px;
      vertical-align: middle;
    }
  }
  &-total {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 10px;
    border: 1px solid #c2edd6;
    width: 278px;
    height: 40px;
    background-color: white;
    line-height: 40px;
    vertical-align: middle;
    text-align: left;
    font-weight: bold;
    font-size: 24px;
    color: #de6263;
  }
}
.bank-tips-content {
  margin-top: 10px;
  font-size: 20px;
  &_title {
    line-height: 130%;
  }
  p {
    margin-top: 10px;
    line-height: 130%;
  }
}
.submit-container {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 8;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  font-size: 0;
}
.order-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  padding: 34px 20px;
  width: 100%;
  height: 158px;
}

.order-detail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .order-detail-content {
    font-size: 30px;
    color: #333;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .product-name {
      display: inline-block;
    }
    img {
      width: 30px;
    }
  }
  .order-detail-price {
    font-size: 40px;
    color: $btnBg;
    .discount-price {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      .price-wrap {
        display: flex;
        flex-direction: column;
        color: $btnBg;
      }
      .discount-total {
        font-size: 40px;
      }
      .price-total {
        text-decoration: line-through;
        text-decoration-color: $btnBg;
        font-size: 40px;
        color: $btnBg;
      }
    }
    .price {
      font-size: 24px;
      color: #333;
      display: flex;
      align-items: center;
      .price-total {
        font-size: 40px;
        color: $btnBg;
        font-weight: bold;
      }
    }
  }
}
.coupon-info-wrap {
  position: absolute;
  width: 100%;
  bottom: 156px;
}
.coupon-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  color: #333;
  padding: 0 20px;
  height: 80px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background: #fff;
  cursor: default;
  box-shadow: 0px -4px 6px -2px $borderActiveShade;
  border: 1px solid #dddddd;
}
.submit-btn {
  color: #fff;
  font-size: 28px;
  padding: 20px 30px;
  background: $btnBg;
  border-radius: 50px;
  box-sizing: border-box;
}

@media screen and (orientation: portrait) {
  .coin-detail {
    &_left {
      flex-direction: column;
    }
    &-info {
      margin-top: 12px;
    }
    &_right {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
    }
  }
}

@media screen and (orientation: landscape) {
  .submit-container {
    width: 898px;
    left: unset;
    margin-left: -35px;
  }
  .coupon-info-wrap {
    bottom: 124px;
  }
  .coupon-info {
    font-size: 22px;
    height: 58px;
    box-sizing: border-box;
  }
  .order-container {
    height: 124px;
    padding: 26px 20px;
  }
  .order-detail {
    .order-detail-content {
      font-size: 18px;
    }
    .order-detail-price {
      font-size: 28px;
      .discount-price {
        .total {
          font-size: 22px;
        }
        .discount-total {
          font-size: 28px;
        }
        .price-total {
          font-size: 28px;

          &.coupon {
            font-size: 16px;
          }
        }
      }
      .price {
        font-size: 22px;

        .price-total {
          font-size: 28px;
        }
      }
    }
  }
  .current-type-container {
    &.is-bank {
      margin-top: 10px;
    }
  }
  .submit-btn {
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    align-self: center;
  }
}
</style>
